package com.havn.app.features.followups.domain

data class FollowUp(
    val id: String,
    val visitorId: String,
    val assignedAgentId: String,
    val channel: FollowUpChannel,
    val status: FollowUpStatus,
    val dueAt: String,
    val completedAt: String? = null,
    val subject: String,
    val body: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null
)

data class FollowUpDraft(
    val visitorId: String,
    val channel: FollowUpChannel,
    val dueAt: String,
    val subject: String,
    val body: String,
    val status: FollowUpStatus = FollowUpStatus.Pending,
    val completedAt: String? = null
)

enum class FollowUpChannel(val label: String, val databaseValue: String) {
    Call("Call", "call"),
    Sms("SMS", "sms"),
    Email("Email", "email"),
    Broker("Broker", "broker"),
    Note("Note", "note");

    companion object {
        fun fromDatabase(value: String?): FollowUpChannel = when (value) {
            "sms" -> Sms
            "email" -> Email
            "broker" -> Broker
            "note" -> Note
            else -> Call
        }
    }
}

enum class FollowUpStatus(val label: String, val databaseValue: String) {
    Pending("Draft", "pending"),
    InProgress("In progress", "in_progress"),
    Completed("Sent", "completed"),
    Cancelled("Cancelled", "cancelled");

    companion object {
        fun fromDatabase(value: String?): FollowUpStatus = when (value) {
            "in_progress" -> InProgress
            "completed" -> Completed
            "cancelled" -> Cancelled
            else -> Pending
        }
    }
}
